var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPencil = function SvgPencil(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "1em",
    viewBox: "0 0 64 64",
    width: "1em",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M43 8.64 9.8 41.81 5.31 56.65a1.64 1.64 0 0 0 2 2l14.88-4.45L55.36 21z",
    fill: "#ffdbaa"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m13.83 56.73-6.56-6.56-2 6.48a1.64 1.64 0 0 0 2 2z",
    fill: "#5a5d59"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M43.06 8.55 9.8 41.81l6.47.52-.28 5.68 5.68-.28.52 6.47 33.26-33.26z",
    fill: "#ffc600"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m50.17 6.217 7.594 7.593a3.39 3.39 0 0 1-.014 4.808l-4.525 4.525-12.387-12.387 4.525-4.525a3.39 3.39 0 0 1 4.794 0z",
    fill: "#fb5058"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m40.854 10.746 12.387 12.387-5.89 5.89-12.386-12.387z",
    fill: "#e7e7e6"
  })));
};
export default SvgPencil;